import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Influencer = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M31.61,21.54l0,10.986l-4.124,2.917l0,7.557l-6.697,0l0,-7.552l-4.118,-2.917l0,-10.991l14.938,0Zm-6.498,19.085l0,-6.408l1.003,-0.707l3.12,-2.209l0,-7.386l-10.188,0l0,7.381l3.116,2.209l1.002,0.708l0,6.412l1.948,0Zm17.888,-19.09l0,9.12l-2.76,2.427l0,6.27l-7.239,0l0,-17.817l9.999,0Zm-28.001,0l0,17.817l-7.239,0l0,-6.27l-2.76,-2.427l0,-9.12l9.999,0Zm-2.375,15.442l0,-13.067l-5.249,0l0,5.671l1.952,1.72l0.808,0.707l0,4.969l2.489,0Zm25.241,-0.005l0,-4.968l0.808,-0.708l1.952,-1.72l0,-5.671l-5.249,0l0,13.067l2.489,0Zm-27.241,-28.742c-2.679,0 -4.85,2.171 -4.85,4.85c0,2.679 2.171,4.849 4.85,4.849c2.679,0 4.85,-2.17 4.85,-4.849c0,-2.679 -2.171,-4.85 -4.85,-4.85Zm13.518,9.699c3.572,0 6.465,-2.892 6.465,-6.464c0,-3.572 -2.897,-6.465 -6.465,-6.465c-3.567,0 -6.464,2.893 -6.464,6.465c0,3.572 2.892,6.464 6.464,6.464Zm13.234,0c2.679,0 4.85,-2.17 4.85,-4.849c0,-2.679 -2.171,-4.85 -4.85,-4.85c-2.679,0 -4.85,2.171 -4.85,4.85c0,2.679 2.171,4.849 4.85,4.849Zm0,-7.324c1.363,0 2.475,1.111 2.475,2.475c0,1.363 -1.112,2.474 -2.475,2.474c-1.363,0 -2.475,-1.111 -2.475,-2.474c0,-1.364 1.112,-2.475 2.475,-2.475Zm-13.234,-3.23c2.257,0 4.09,1.833 4.09,4.09c0,2.256 -1.833,4.089 -4.09,4.089c-2.256,0 -4.089,-1.833 -4.089,-4.089c0,-2.257 1.833,-4.09 4.089,-4.09Zm-13.518,8.179c-1.363,0 -2.475,-1.111 -2.475,-2.474c0,-1.364 1.112,-2.475 2.475,-2.475c1.363,0 2.475,1.111 2.475,2.475c0,1.363 -1.112,2.474 -2.475,2.474Z" fill={fill} />
    </svg>
  );
};

Influencer.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Influencer.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
